import { cn } from "@/lib/utils";
import { type ComponentPropsWithoutRef, forwardRef } from "react";
import { Link } from "react-router";

export interface ExternalLinkProps extends ComponentPropsWithoutRef<typeof Link> {
  className?: string;
}

export const ExternalLink = forwardRef<HTMLAnchorElement, ExternalLinkProps>(
  ({ className, target = "_blank", rel = "noopener noreferrer", ...props }, ref) => {
    return <Link ref={ref} target={target} rel={rel} prefetch="viewport" className={cn(className)} {...props} />;
  },
);

ExternalLink.displayName = "ExternalLink";
